import { __assign, __read, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Button } from "../button";
import { Icon } from "../icon";
import { useDefault } from "../_util/use-default";
import { useConfig } from "../_util/config-context";
import { useTranslation } from "../i18n";
export var AlertNotice = React.forwardRef(function AlertNotice(_a, ref) {
    var title = _a.title, children = _a.children, className = _a.className, open = _a.open, defaultOpen = _a.defaultOpen, onOpenChange = _a.onOpenChange, props = __rest(_a, ["title", "children", "className", "open", "defaultOpen", "onOpenChange"]);
    var _b = __read(useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _b[0], setIsOpened = _b[1];
    var classPrefix = useConfig().classPrefix;
    var t = useTranslation();
    var alertClassName = classNames(classPrefix + "-alert", classPrefix + "-alert--notice", isOpened && "is-expanded", className);
    var alertElement = (React.createElement("div", __assign({ ref: ref, className: alertClassName }, props),
        React.createElement("span", { className: classPrefix + "-alert__decoration" },
            React.createElement(Icon, { type: "notice-blue" })),
        React.createElement("div", { className: classPrefix + "-alert__info" },
            React.createElement("p", null, title),
            isOpened && children),
        React.createElement("div", { className: classPrefix + "-alert__operational" }, children && (React.createElement(Button, { type: "icon", htmlType: "button", icon: isOpened ? "arrowup" : "arrowdown", "aria-label": isOpened ? t.collapse : t.expand, onClick: function () { return setIsOpened(!isOpened); } })))));
    return alertElement;
});
AlertNotice.displayName = "AlertNotice";
//# sourceMappingURL=AlertNotice.js.map